import { render } from "./CounterWidget.vue?vue&type=template&id=1a4474d6"
import script from "./CounterWidget.vue?vue&type=script&lang=js"
export * from "./CounterWidget.vue?vue&type=script&lang=js"

import "./CounterWidget.vue?vue&type=style&index=0&id=1a4474d6&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__